<div class="relative">
  <div class="container w-[260px]  min-w-full">
    <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
      <div class="flex items-center gap-3 w-full">
        <div>
          <tui-svg src="tuiIconUserCheckLarge" style="color: black;"></tui-svg>
        </div>
        <div>
          <h3 class="flex items-center text-black text-[1.5rem] font-bold">Attendance</h3>
        </div>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <div class="">
          <button tuiButton appearance="" (click)="toggle()" class="">
            <div class="flex justify-center items-center btn-outline w-[80px] sm:w-[160px]">
              <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
                style="color: #bb0021;"></tui-svg>
              <p class="hidden sm:block">Advanced Search</p>
            </div>
          </button>
        </div>
        <div class="">
          <button tuiButton appearance="" class="" (click)="navigateToAdd()">
            <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
              <p class="flex justify-center items-center text-[13px] h-[24px]">Add Attendance</p>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-2 sm:mt-0 mb-3">
      <div class=" flex flex-col lg:flex-row justify-between" *ngIf="showSearch">
        <div class="flex sm:items-center gap-1 flex-col sm:flex-row">
          <div class="w-full sm:w-60">
            <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="true" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="" [(ngModel)]="searchText"
              (tuiValueChanges)="cancelSearch($event)">
              Search
              <input tuiTextfield type="text" />
            </tui-input>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-60 py-3">
            <tui-input-date-range class="b-form" [(ngModel)]="dateFilter" tuiTextfieldSize="m">
              Choose dates
            </tui-input-date-range>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-[100px] my-3">
            <button tuiButton tuiTextfieldSize="s" type="button" class="w-full" (click)="search()">
              <tui-svg src="tuiIconSearchLarge" class="pr-2 text-white"></tui-svg>
              <span class="text-white">Search</span>
            </button>
          </div>
        </div>
        <!--            <div class="text-[#FFFFFFB8] flex gap-1 items-center justify-end">-->
        <!--                <label>-->
        <!--                    Active-->
        <!--                    <tui-toggle-->
        <!--                        size="l"-->
        <!--                        class=""-->
        <!--                    ></tui-toggle>-->
        <!--                </label>-->
        <!--            </div>-->
      </div>

      <div class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2  w-full" *ngIf="statusMsg">
        <div class="flex items-center">
          <img src="/assets/img/resulticon.png" alt="">
          <p class="text-black pl-2">{{showText()}}</p>
        </div>
        <div>
          <button class="text-[#bb0021] hover:scale-110 transition-all duration-100"
            (click)="resetStatus()">Reset</button>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <tui-loader [overlay]="true" [showLoader]="isLoading" class="">
        <div *ngIf="attendanceRows.length > 0" class="overflow-x-scroll" style="white-space: nowrap">
          <table class="tui-table w-full">
            <thead tuiThead>
              <tr class="tui-table__tr">
                <th class="tui-table__th">Club ID</th>
                <th class="tui-table__th">Full Name</th>
                <th class="tui-table__th">Date</th>
                <th class="tui-table__th">Session Type</th>
                <!-- <th class="tui-table__th">Status</th> -->
              </tr>
            </thead>
            <tbody>
              <tr class="tui-table__tr" *ngFor="let row of attendanceRows">
                <td class="tui-table__td">{{ row.memberId }}</td>
                <td class="tui-table__td">{{ row.firstname }} {{ row.lastname }}</td>
                <td class="tui-table__td">{{ formatDate(row.date) }}</td>
                <td class="tui-table__td">{{ row.session }}</td>
                <!-- <td class="tui-table__td">
                  <app-status-badge [status]="row.status"></app-status-badge>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="attendanceRows.length === 0 && !isLoading" class="mt-3">
          <p class="text-[#D8D8D8] text-center">No Data</p>
        </div>
      </tui-loader>
    </div>

    <div class="text-black py-10 flex justify-end w-full max-w-full">
      <tui-pagination [index]="pageSize.pageIndex-1" [length]="pageSize.length" (indexChange)="goToPage($event)"
        class="text-black">
      </tui-pagination>
    </div>
  </div>
</div>